import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/entitlement/erpSalesOrderItems/initialState.erpSalesOrderItems.data';
import {
  fetchERPSalesOrderItems as fetchERPSalesOrderItemsAPI,
  fetchImportStatus as fetchImportStatusAPI,
  fetchMappingType as fetchMappingTypeAPI,
  fetchCustomerNameContainsData as fetchCustomerNameContainsDataAPI,
  saveErpSalesOrderItemDisplayData as saveErpSalesOrderItemDisplayDataAPI,
  orderGroupSmartSearchData as orderGroupSmartSearchDataAPI,
  //Modals
  fetchAccountingGroupsData as fetchAccountingGroupsDataAPI,
  searchProductCodeName as searchProductCodeNameAPI,
  fetchmcnAccountingGroups as fetchmcnAccountingGroupsAPI,
  fetchCustomerSearch as fetchCustomerSearchAPI,
  mcncustomerNameSmartSearchData as mcncustomerNameSmartSearchDataAPI,
  getErpSalesItemsEntitlements as getErpSalesItemsEntitlementsAPI,
  createEntitlement as createEntitlementAPI,
  resetLine as resetLineAPI,
  jobCreateEntitlements as jobCreateEntitlementsAPI,
} from '../../../apis/erpSalesOrderItemsAPI';
import {
  CHECK_BOX_VALUE,
  ERP_SALES_ORDER_ITEMS_DATA,
  handlePending,
  handleRejection,
} from '../../../constants';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { ACTIONS_ERP_SALES_ORDER_ITEMS } from '../../../constants/actionCreator';

//API to get ERP Sales Order Items Data
export const fetchERPSalesOrderItemsData = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_ERP_SALES_ORDER_ITEMS,
  fetchERPSalesOrderItemsAPI
);

//Fetch Import Status Data
export const fetchImportStatusData = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_IMPORT_STATUS,
  fetchImportStatusAPI
);

//Fetch Mapping Type Data
export const fetchMappingTypeData = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_MAPPING_TYPE,
  fetchMappingTypeAPI
);

//Fetch Custome Name Contains Data
export const customerNameSmartSearchData = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_CUSTOMER_NAME_CONTAINS,
  fetchCustomerNameContainsDataAPI
);

//Fetch Order Group  Name Contains Data
export const orderGroupSmartSearchData = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_ORDER_GROUP_NAME_CONTAINS,
  orderGroupSmartSearchDataAPI
);

export const updateErpSalesOrderItemDisplayData = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.UPDATE_ERP_SALES_ORDER_Item,
  saveErpSalesOrderItemDisplayDataAPI
);

//Modals
//API to get data for Accounting Group
export const fetchAccountingGroups = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_ACCOUNTING_GROUPS,
  fetchAccountingGroupsDataAPI
);

//API to get data for Service Product
export const searchProductCodeNameData = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_PRODUCT_CODE_NAME,
  searchProductCodeNameAPI
);

//API to get data for Accounting Groups
export const fetchmcnAccountingGroups = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_MCN_ACCOUNTING_GROUPS,
  fetchmcnAccountingGroupsAPI
);

//API to get data for Customer Name contains search
export const mcncustomerNameSmartSearchData = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_PRODUCT_NAME_CONTAINS,
  mcncustomerNameSmartSearchDataAPI
);

//API to get data for Global Customer Data
export const getAllCustomersForParentGlobalModal = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.FETCH_ALL_CUSTOMERS_FOR_PARENT_GLOBAL_MODAL,
  fetchCustomerSearchAPI
);

//API to get data for Global Customer Data
export const getErpSalesItemsEntitlements = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.EPR_SALES_ORDER_ITEMS_ENTITLEMENTS,
  getErpSalesItemsEntitlementsAPI
);

export const createEntitlement = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.CREATE_ENTITLEMENTS,
  createEntitlementAPI
);

export const resetLine = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.RESET_LINE,
  resetLineAPI
);

export const jobCreateEntitlements = createAsyncThunkWrapper(
  ACTIONS_ERP_SALES_ORDER_ITEMS.JOB_CREATE_ENTITLEMENTS,
  jobCreateEntitlementsAPI
);

const erpSalesOrderItemsSlice = createSlice({
  name: 'erpSalesOrderItems',
  initialState,
  reducers: {
    //Reset
    handleResetErpSalesOrderItemsPage: (state) => {
      if (state.searchOption === ERP_SALES_ORDER_ITEMS_DATA.searchOption1) {
        state.erpSalesOrderItemSearchForm =
          initialState.erpSalesOrderItemSearchForm;
        state.erpSalesOrderItemsSearchData = [];
        state.erpSalesOrderItemsDisplayStatus = false;
      } else if (
        state.searchOption === ERP_SALES_ORDER_ITEMS_DATA.searchOption2
      ) {
        state.erpSalesOrderItemsFastSearchForm =
          initialState.erpSalesOrderItemsFastSearchForm;
        state.erpSalesOrderItemsSearchData = [];
        state.erpSalesOrderItemsDisplayStatus = false;
      } else {
        return initialState;
      }
    },
    handlereseterpSalesOrderItemsGRIDCount: (state, action) => {
      state.erpSalesOrderItemsCount = action?.payload || initialState.erpSalesOrderItemsCount;
    },
    setOpenAlertBox: (state) => {
      state.alertDialog = true;
    },
    setCloseAlertBox: (state) => {
      state.alertDialog = false;
    },
    setAlertMessage: (state, action) => {
      state.alertText = action?.payload || initialState.alertText;
    },
    selectSearchOption: (state, action) => {
      state.searchOption = action?.payload || initialState.searchOption;
    },
    handleSearchOption: (state, action) => {
      state.searchOption = action?.payload || initialState.searchOption;
      state.erpSalesOrderItemSearchForm =
        initialState.erpSalesOrderItemSearchForm;
      state.erpSalesOrderItemsFastSearchForm =
        initialState.erpSalesOrderItemsFastSearchForm;
    },
    handleFromErpSalesOrderNavigate: (state, action) => {
      state.fromErpSalesOrderNavigate = action?.payload;
    },
    handleERPSalesOrderItemsDisplay: (state, action) => {
      state.erpSalesOrderItemsDisplayStatus =
        action?.payload || initialState.erpSalesOrderItemsDisplayStatus;
      state.apiSuccessResponse.updateUnsupportedDisplayData = '';
    },
    handleloadingForfetchERPSalesOrderItemsData: (state, action) => {
      state.loadingForfetchERPSalesOrderItemsData = action?.payload;
    },
    handleErpSalesOrderItemsSearchDate: (state, action) => {
      state.erpSalesOrderItemSearchForm[action?.payload?.name] =
        action?.payload?.value;
    },
    handleImportStatus: (state, action) => {
      state.erpSalesOrderItemSearchForm.importStatusId =
        action?.payload?.value || 0;
    },
    handleMappingType: (state, action) => {
      state.erpSalesOrderItemSearchForm.mappingTypeId =
        action?.payload?.value || 0;
    },
    handleFastFindSearchOptions: (state, action) => {
      state.erpSalesOrderItemsFastSearchForm[action.payload.name] =
        action?.payload?.value ||
        initialState.erpSalesOrderItemsFastSearchForm[action?.payload?.name];
    },
    handleSelectedTab: (state, action) => {
      state.selectedTab = action?.payload;
    },
    setCustomerSelectedValue: (state, action) => {
      state.multipleInputsSelectedValues[action?.payload?.name] =
        action?.payload?.value;
      state.erpSalesOrderItemSearchForm.customerName =
        action?.payload?.value || '';
    },
    setCustomerNameInputValue: (state, action) => {
      state.selectedCustomerNameInputValue[action?.payload?.name] =
        action?.payload?.value;
    },
    setCustomerNameSearchTerm: (state, action) => {
      state.customerNameSearchTerm = action?.payload;
    },
    setShowCustomernameSelectedValue: (state, action) => {
      state.showCustomernameSelectedValue = action?.payload;
    },
    setOrderGroupsSelectedValue: (state, action) => {
      state.ordergroupmultipleInputsSelectedValues[action?.payload?.name] =
        action?.payload?.value;
      state.erpSalesOrderItemSearchForm.orderGroupName =
        action?.payload?.value || '';
    },
    setOrderGroupInputValue: (state, action) => {
      state.selectedOrderGroupInputValue[action?.payload?.name] =
        action?.payload?.value;
    },
    setOrderGroupSearchTerm: (state, action) => {
      state.orderGroupSearchTerm = action?.payload;
    },
    setShowOrdergroupSelectedValue: (state, action) => {
      state.showOrdergroupSelectedValue = action?.payload;
    },
    handleImportStatusOperator: (state, action) => {
      state.erpSalesOrderItemSearchForm.importStatusOperator =
        action?.payload ||
        initialState.erpSalesOrderItemSearchForm?.importStatusOperator;
    },
    handleErpSalesOrderItemsGridSelectedRow: (state, action) => {
      state.erpSalesOrderItemsGridSelectedRow = action?.payload;
      state.apiSuccessResponse.fastfindResult = '';
      state.apiSuccessResponse.updateUnsupportedDisplayData = '';
    },
    handleErpSalesOrderItemsUnsupportedFlag: (state, action) => {
      state.erpSalesOrderItemsUnsupportedFlag = action?.payload;
      state.erpSalesOrderItemsGridSelectedRow.unsupportedFlag = action?.payload;
    },
    setERPSalesOrderItemsGridFilters: (state, action) => {
      const { columnName, value } = action?.payload || {};
      state.erpSalesOrderItemsGridColumnFilters[columnName] = value;
    },
    setErpSalesOrderItemsSearchGridColData: (state, action) => {
      state.erpSalesOrderItemsColData = action?.payload ? action.payload : [];
    },
    //Modals
    //Accounting Group
    setSelectedAccountGridRowsData: (state, action) => {
      if (
        state.erpSalesOrderItemsSearchModal.parentGlobalModal
          .openParentGlobalCustomerNoModal
      ) {
        state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroupName =
          action.payload[0]?.name || '';
        state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroup =
          action.payload[0]?.accountingGroupCode || '';
      } else {
        state.erpSalesOrderItemsSearchModal.gridAccountingRowSelectedData =
          action?.payload?.length > 0
            ? action.payload
            : ERP_SALES_ORDER_ITEMS_DATA.inputModalDefaultVal;
        state.erpSalesOrderItemsSearchModal.gridAccountingRowSelectedCount =
          action?.payload?.length > 0 ? action.payload.length : 0;
        state.erpSalesOrderItemSearchForm.accountingGroupName = action
          .payload[0]?.name
          ? action.payload[0].name
          : ERP_SALES_ORDER_ITEMS_DATA.inputModalDefaultVal;
        state.erpSalesOrderItemSearchForm.accountingGroupCode = action
          .payload[0]?.accountingGroupCode
          ? action.payload[0].accountingGroupCode
          : '';
        state.erpSalesOrderItemsSearchModal.openAccountingGroupModal = false;
        state.erpSalesOrderItemSearchForm.accountingGroupName =
          action.payload[0]?.name || '';
        state.erpSalesOrderItemSearchForm.accountingGroupCode =
          action.payload[0]?.accountingGroupCode || '';
      }
    },
    handleFilteredAccountingGroupData: (state, action) => {
      state.erpSalesOrderItemsSearchModal.accountingGroupSearchData =
        action.payload;
    },
    setAccountingGroupModalOpen: (state) => {
      state.erpSalesOrderItemsSearchModal.openAccountingGroupModal = true;
      state.erpSalesOrderItemsSearchModal.accountingGroupSearchForm =
        initialState.erpSalesOrderItemsSearchModal.accountingGroupSearchForm;
    },
    setAccountingGroupModalClose: (state) => {
      state.erpSalesOrderItemsSearchModal.openAccountingGroupModal = false;
      state.erpSalesOrderItemsSearchModal.accountingGroupSearchForm =
        initialState.erpSalesOrderItemsSearchModal.accountingGroupSearchForm;
    },
    setAccouningGroupFormFeilds: (state, action) => {
      state.erpSalesOrderItemsSearchModal.accountingGroupSearchForm[
        action?.payload?.name
      ] = action?.payload?.value;
    },
    //Sales Product
    setSalesProduct: (state, action) => {
      state.erpSalesOrderItemsSearchModal.salesProductModal.salesProductField =
        action.payload ? action.payload : '';
    },
    setSalesModalData: (state, action) => {
      const { id, erpSalesProductId, salesProductCode, salesProductName } =
        action?.payload
          ? action.payload
          : initialState.erpSalesOrderItemsSearchModal.salesProductModal
            .salesModalData;
      state.erpSalesOrderItemsSearchModal.salesProductModal.salesModalData = {
        ...state.erpSalesOrderItemsSearchModal?.salesProductModal
          ?.salesModalData,
        id,
        erpSalesProductId,
        salesProductCode,
        salesProductName,
      };

      state.erpSalesOrderItemSearchForm.salesProductName =
        action?.payload?.salesProductName ||
        initialState.erpSalesOrderItemSearchForm.salesProductName;
      state.erpSalesOrderItemSearchForm.salesProductId =
        action?.payload?.erpSalesProductId ||
        initialState.erpSalesOrderItemSearchForm.salesProductId;
    },
    setOpenSalesProductModal: (state) => {
      state.erpSalesOrderItemsSearchModal.salesProductModal.openSalesProductModal = true;
      state.erpSalesOrderItemsSearchModal.salesProductModal.codeField =
        initialState.erpSalesOrderItemsSearchModal.salesProductModal.codeField;
      state.erpSalesOrderItemsSearchModal.salesProductModal.nameField =
        initialState.erpSalesOrderItemsSearchModal.salesProductModal.nameField;
    },
    setCloseSalesProductModal: (state) => {
      state.erpSalesOrderItemsSearchModal.salesProductModal.openSalesProductModal = false;
      resetModalFields(state);
    },
    resetModalFields: (state) => {
      state.erpSalesOrderItemsSearchModal.salesProductModal.codeField =
        initialState.erpSalesOrderItemsSearchModal.salesProductModal.codeField;
      state.erpSalesOrderItemsSearchModal.salesProductModal.nameField =
        initialState.erpSalesOrderItemsSearchModal.salesProductModal.nameField;
      state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameResult =
        initialState.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameResult;
    },
    setSalesProductCode: (state, action) => {
      state.erpSalesOrderItemsSearchModal.salesProductModal.codeField =
        action.payload ? action.payload : '';
    },
    //Master Customer Number Modal
    setmcnSelectedValue: (state, action) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs[
        action?.payload?.name
      ] = action?.payload?.value;
    },
    setmcnCustomerNameInputValue: (state, action) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs[
        action?.payload?.name
      ] = action?.payload?.value || '';
    },
    setDropDownValue: (state, action) => {
      //dropdown will always have value
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalDropDownValues[
        action?.payload?.name
      ] = action?.payload?.value;
    },
    setmcnShowCustomernameSelectedValue: (state, action) => {
      state.erpSalesOrderItemsSearchModal.showCustomernameSelectedValue =
        action?.payload;
    },
    setmcnSelectedAccountGridRowsData: (state, action) => {
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.gridAccountingRowSelectedData =
        action.payload ? action.payload : [];
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.gridAccountingRowSelectedCount =
        action?.payload?.length || 0;
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroupName =
        action.payload[0]?.name || '';
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs.accountingGroup =
        action.payload[0]?.accountingGroupCode || '';
    },
    setmcnAccountingGroupModalOpen: (state) => {
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.openAccountingGroupModal = true;
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm =
        initialState.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm;
    },
    setmcnAccountingGroupModalClose: (state) => {
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.openAccountingGroupModal = false;
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm =
        initialState.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm;
    },
    setmcnAccouningGroupFormFeilds: (state, action) => {
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm[
        action.payload.name
      ] = action?.payload?.value || '';
    },
    setParentGlobalCustomerNoModalOpen: (state) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.openParentGlobalCustomerNoModal = true;
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm =
        initialState.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm;
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs;
    },
    setParentGlobalCustomerNoModalClose: (state) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.openParentGlobalCustomerNoModal = false;
      state.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm =
        initialState.erpSalesOrderItemsSearchModal.accountingGroupModal.accountingGroupSearchForm;
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs;
    },
    setmcnCustomerNameSearchTerm: (state, action) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.customerNameSearchTerm =
        action.payload ? action.payload : '';
    },
    setSelectedParentGlobalGridRowsData: (state, action) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.gridParentGlobalCustomerNoRowSelectedData =
        action.payload ? action.payload : [];
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.gridParentGlobalGridRowSelectedCount =
        action?.payload?.length || 0;
      state.erpSalesOrderItemsSearchModal.multipleInputsSelectedValues.parentPsCustomerCode =
        action.payload[0]?.psCustomerCode.trim() || '';
      state.erpSalesOrderItemsSearchModal.masterCustomerNumber =
        action.payload[0]?.psCustomerCode.trim() || '';
      state.erpSalesOrderItemSearchForm.masterCustomerNumber =
        action.payload[0]?.psCustomerCode.trim() || '';
      state.erpSalesOrderItemSearchForm.masterCustomerName =
        action.payload[0]?.name.trim() || '';
    },
    setCustomersGridPageSize: (state, action) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs.recordCount =
        action.payload ? action.payload : 0;
    },
    handleParentGlobalModalReset: (state) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalMultipleInputs;
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalDropDownValues =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalModalDropDownValues;
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.showCustomernameSelectedValue =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.showCustomernameSelectedValue;
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.customerNameSearchTerm =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.customerNameSearchTerm;
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridData =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridData;
      state.erpSalesOrderItemsSearchModal.parentGlobalGridData =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridData;
      state.erpSalesOrderItemsSearchModal.parentGlobalGridTotalRecords =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridTotalRecords;
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridTotalRecords =
        initialState.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridTotalRecords;
    },
    handleOpenParentGlobalCustomerNoModal: (state, action) => {
      state.erpSalesOrderItemsSearchModal.parentGlobalModal.openParentGlobalCustomerNoModal =
        action?.payload;
    },
    setCustomerNumber: (state, action) => {
      state.erpSalesOrderItemSearchForm.masterCustomerNumber = action?.payload;
    },
    resetValues: (state) => {
      state.createEntitlementLoading = initialState.createEntitlementLoading;
      state.createEntitlementFound = initialState.createEntitlementFound;
      state.resetLineLoading = initialState.resetLineLoading;
      state.resetLineFound = initialState.resetLineFound;
      state.erpSalesOrderItemsUnsupportedFlag =
        initialState.erpSalesOrderItemsUnsupportedFlag;
      state.erpSalesOrderItemsGridSelectedRow =
        initialState.erpSalesOrderItemsGridSelectedRow;
      if (state.fromErpSalesOrderNavigate === true) {
        state.fromErpSalesOrderNavigate = false;
        state.searchOption = ERP_SALES_ORDER_ITEMS_DATA.searchOption1;
      }
      else {
        state.searchOption = state.searchOption === ('' || ERP_SALES_ORDER_ITEMS_DATA.searchOption1) ? initialState.searchOption : ERP_SALES_ORDER_ITEMS_DATA.searchOption2;
      }
    },
    hendleAGChange: (state, action) => {
      state.erpSalesOrderItemSearchForm.accountingGroupName =
        action.payload || '';
      state.erpSalesOrderItemSearchForm.accountingGroupCode =
        action.payload || '';
    },
    hendleSalesProductChange: (state, action) => {
      state.erpSalesOrderItemSearchForm.salesProductId = action?.payload || '';
      state.erpSalesOrderItemSearchForm.salesProductName =
        action?.payload || '';
    },
    handleOnSaveRefreshSearch: (state, action) => {
      state.onSaveRefreshSearch = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchERPSalesOrderItemsData.pending, (state, action) => {
        handlePending(state, action);
        if (state.searchOption === ERP_SALES_ORDER_ITEMS_DATA.searchOption1) {
          //Search Options
          state.erpSalesOrderItemSearchGridLoading = true;
          state.isErpSalesOrderItemsResultsFound = null;
          state.erpSalesOrderItemsSearchData = [];
          state.erpSalesOrderItemsCount = 0;
        }

        if (state.searchOption === ERP_SALES_ORDER_ITEMS_DATA.searchOption2) {
          //Search Options
          state.loadingForfetchERPSalesOrderItemsData = true;
          state.isErpSalesOrderItemsFastSearchResultsFound = false;
          state.erpSalesOrderItemsFastSearchData =
            initialState.erpSalesOrderItemsFastSearchData;
          state.apiSuccessResponse.fastfindResult = '';
        }
      })
      .addCase(fetchERPSalesOrderItemsData.fulfilled, (state, action) => {
        state.loadingForfetchERPSalesOrderItemsData = false;
        state.erpSalesOrderItemSearchGridLoading = false;
        if (state.searchOption === ERP_SALES_ORDER_ITEMS_DATA.searchOption1) {
          //Search Options
          state.erpSalesOrderItemsSearchData =
            action?.payload?.salesOrderItems || [];
          state.isErpSalesOrderItemsResultsFound =
            action?.payload?.salesOrderItems?.length > 0;
          state.isErpSalesOrderItemsFastSearchResultsFound = true;
          state.erpSalesOrderItemsCount =
            action?.payload?.totalRecords ||
            initialState.erpSalesOrderItemsCount;
          state.erpSalesOrderItemsDisplayStatus = false;
        }

        if (state.searchOption === ERP_SALES_ORDER_ITEMS_DATA.searchOption2) {
          if (action?.payload?.salesOrderItems?.length > 0) {
            //Fast Find
            state.erpSalesOrderItemsFastSearchData =
              action?.payload?.salesOrderItems[0] || [];
            if (action?.payload?.salesOrderItems?.length > 0) {
              state.erpSalesOrderItemsGridSelectedRow =
                action?.payload?.salesOrderItems[0];
            }
            state.isErpSalesOrderItemsFastSearchResultsFound =
              action?.payload?.salesOrderItems?.length > 0;
            state.erpSalesOrderItemsFastSearchCount =
              action?.payload?.totalRecords ||
              initialState.erpSalesOrderItemsCount;
            state.apiSuccessResponse.fastfindResult = 'success';
            state.erpSalesOrderItemsSearchData = [];
            state.isErpSalesOrderItemsResultsFound = true;
            state.erpSalesOrderItemsCount = 0;
            state.erpSalesOrderItemsUnsupportedFlag =
              action?.payload?.salesOrderItems[0]?.unsupportedFlag ||
              CHECK_BOX_VALUE.no;
          } else {
            state.apiSuccessResponse.fastfindResult = 'error';
          }
        }
      })
      .addCase(fetchERPSalesOrderItemsData.rejected, (state, action) => {
        state.loadingForfetchERPSalesOrderItemsData = false;
        if (state.searchOption === ERP_SALES_ORDER_ITEMS_DATA.searchOption1) {
          handleRejection(state, action);
          state.erpSalesOrderItemsSearchData = [];
          state.erpSalesOrderItemSearchGridLoading = false;
          state.isErpSalesOrderItemsResultsFound = false;
          state.isErpSalesOrderItemsResultsFound = 0;
        }

        if (state.searchOption === ERP_SALES_ORDER_ITEMS_DATA.searchOption2) {
          state.isErpSalesOrderItemsFastSearchResultsFound = false;
        }

        state.erpSalesOrderItemsDisplayStatus = false;
      })

      .addCase(fetchImportStatusData.pending, (state, action) => {
        handlePending(state, action);
      })
      .addCase(fetchImportStatusData.fulfilled, (state, action) => {
        state.importStatusData = action?.payload || [];
      })
      .addCase(fetchImportStatusData.rejected, (state, action) => {
        handleRejection(state, action);
      })

      .addCase(fetchMappingTypeData.pending, (state, action) => {
        handlePending(state, action);
      })
      .addCase(fetchMappingTypeData.fulfilled, (state, action) => {
        state.mappingTypeData = action?.payload || [];
      })
      .addCase(fetchMappingTypeData.rejected, (state, action) => {
        handleRejection(state, action);
      })

      .addCase(customerNameSmartSearchData.pending, (state) => {
        state.inputError = null;
      })
      .addCase(customerNameSmartSearchData.fulfilled, (state, action) => {
        action?.payload?.length > 0
          ? (state.customerName = action?.payload)
          : (state.customerName = []);
      })
      .addCase(customerNameSmartSearchData.rejected, (state, action) => {
        state.inputError = action?.payload;
      })

      .addCase(orderGroupSmartSearchData.pending, (state) => {
        state.inputError = null;
      })
      .addCase(orderGroupSmartSearchData.fulfilled, (state, action) => {
        action?.payload?.length > 0
          ? (state.orderGroup = action?.payload)
          : (state.orderGroup = []);
      })
      .addCase(orderGroupSmartSearchData.rejected, (state, action) => {
        state.inputError = action?.payload;
      })

      .addCase(updateErpSalesOrderItemDisplayData.pending, (state, action) => {
        handlePending(state, action);
        state.isUnsupportedFlagUpdated = true;
        state.apiSuccessResponse.updateUnsupportedDisplayData = '';
      })
      .addCase(updateErpSalesOrderItemDisplayData.fulfilled, (state) => {
        state.erpSalesOrderItemsDisplayStatus = true;
        state.isUnsupportedFlagUpdated = false;
        state.apiSuccessResponse.updateUnsupportedDisplayData = 'success';
      })
      .addCase(updateErpSalesOrderItemDisplayData.rejected, (state, action) => {
        handleRejection(state, action);
        state.isUnsupportedFlagUpdated = false;
        state.apiSuccessResponse.updateUnsupportedDisplayData = 'error';
      })

      //Modals
      .addCase(fetchAccountingGroups.pending, (state) => {
        state.erpSalesOrderItemsSearchModal.accountingGroupSearchData = [];
        state.isAccountingGroupsResultsFound = null;
      })
      .addCase(fetchAccountingGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.erpSalesOrderItemsSearchModal.accountingGroups = action?.payload
          ? action?.payload?.accountingGroups
          : [];
        state.erpSalesOrderItemsSearchModal.accountingGroupSearchData = action
          ?.payload?.accountingGroups
          ? action?.payload?.accountingGroups
          : [];
        state.erpSalesOrderItemsSearchModal.accountingGroupGridTotalRecords =
          action?.payload ? action?.payload?.totalCount : 0;
        state.isAccountingGroupsResultsFound =
          action?.payload?.accountingGroups?.length === 0;
      })
      .addCase(fetchAccountingGroups.rejected, (state, action) => {
        handleRejection(state, action);
        state.erpSalesOrderItemsSearchModal.accountingGroupSearchData = [];
        state.erpSalesOrderItemsSearchModal.accountingGroupGridTotalRecords = 0;
        state.isAccountingGroupsResultsFound = true;
      })

      .addCase(searchProductCodeNameData.pending, (state) => {
        state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameLoading = true;
        state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameResult =
          [];
        state.isSalesProductResultsFound = null;
      })
      .addCase(searchProductCodeNameData.fulfilled, (state, action) => {
        state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameLoading = false;
        state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameResult =
          action.payload ? action.payload : [];
        state.isSalesProductResultsFound = action?.payload?.length === 0;
        state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameTotalRecords =
          action.payload ? action?.payload[0]?.totalRecords : 0;
      })
      .addCase(searchProductCodeNameData.rejected, (state) => {
        state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameLoading = false;
        state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameResult =
          [];
        state.isSalesProductResultsFound = true;
        state.erpSalesOrderItemsSearchModal.salesProductModal.searchProductCodeNameTotalRecords = 0;
      })

      .addCase(fetchmcnAccountingGroups.pending, (state) => {
        state.erpSalesOrderItemsSearchModal.accountingGroupSearchData = [];
        state.isAccountingGroupsResultsFound = null;
      })
      .addCase(fetchmcnAccountingGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.erpSalesOrderItemsSearchModal.accountingGroups = action?.payload
          ? action?.payload?.accountingGroups
          : [];
        state.erpSalesOrderItemsSearchModal.accountingGroupSearchData = action
          ?.payload?.accountingGroups
          ? action?.payload?.accountingGroups
          : [];
        state.erpSalesOrderItemsSearchModal.accountingGroupGridTotalRecords =
          action?.payload ? action?.payload?.totalCount : 0;
        state.isAccountingGroupsResultsFound =
          action?.payload?.accountingGroups?.length === 0;
      })
      .addCase(fetchmcnAccountingGroups.rejected, (state) => {
        state.erpSalesOrderItemsSearchModal.accountingGroupSearchData = [];
        state.erpSalesOrderItemsSearchModal.accountingGroupGridTotalRecords = 0;
        state.isAccountingGroupsResultsFound = true;
      })

      .addCase(mcncustomerNameSmartSearchData.pending, (state) => {
        state.inputError = null;
      })
      .addCase(mcncustomerNameSmartSearchData.fulfilled, (state, action) => {
        if (
          state.erpSalesOrderItemsSearchModal.parentGlobalModal
            .openParentGlobalCustomerNoModal
        ) {
          action?.payload?.length > 0
            ? (state.erpSalesOrderItemsSearchModal.parentGlobalModal.name =
              action.payload)
            : (state.erpSalesOrderItemsSearchModal.parentGlobalModal.name = []);
        } else {
          action?.payload?.length > 0
            ? (state.erpSalesOrderItemsSearchModal.name = action?.payload)
            : (state.erpSalesOrderItemsSearchModal.name = []);
        }
      })
      .addCase(mcncustomerNameSmartSearchData.rejected, (state, action) => {
        state.inputError = action?.payload;
      })

      .addCase(getAllCustomersForParentGlobalModal.pending, (state) => {
        state.loading = true;
        state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridData =
          [];
        state.erpSalesOrderItemsSearchModal.parentGlobalModal.isParentGlobalResultsFound =
          null;
      })
      .addCase(
        getAllCustomersForParentGlobalModal.fulfilled,
        (state, action) => {
          state.loading = false;
          if (action?.payload?.length > 0) {
            state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridData =
              action?.payload?.sort((a, b) => a.name - b.name);
            state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridTotalRecords =
              action.payload ? action?.payload[0]?.totalRecords : 0;
            state.erpSalesOrderItemsSearchModal.parentGlobalModal.isParentGlobalResultsFound =
              action?.payload?.length === 0;
          } else {
            state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridData =
              [];
            state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridTotalRecords = 0;
            state.erpSalesOrderItemsSearchModal.parentGlobalModal.isParentGlobalResultsFound = true;
          }
        }
      )
      .addCase(
        getAllCustomersForParentGlobalModal.rejected,
        (state, action) => {
          state.loading = false;
          state.inputError = action?.payload;
          state.erpSalesOrderItemsSearchModal.parentGlobalModal.parentGlobalGridTotalRecords = 0;
          state.erpSalesOrderItemsSearchModal.parentGlobalModal.isParentGlobalResultsFound = true;
        }
      )

      .addCase(getErpSalesItemsEntitlements.pending, (state) => {
        state.entitlementsTotalRecords = 0;
        state.entitlementsResultFound = null;
        state.erpSalesOrderItemsEnititlement = [];
      })
      .addCase(getErpSalesItemsEntitlements.fulfilled, (state, action) => {
        state.erpSalesOrderItemsEnititlement = action?.payload?.entitlements
          ? action?.payload?.entitlements?.map((item, i) => {
            item.id = i;
            return item;
          })
          : [];
        state.entitlementsTotalRecords = action?.payload?.totalRecords || 0;
        state.entitlementsResultFound = true;
      })
      .addCase(getErpSalesItemsEntitlements.rejected, (state) => {
        state.erpSalesOrderItemsEnititlement = [];
        state.entitlementsTotalRecords = 0;
        state.entitlementsResultFound = true;
      })

      .addCase(createEntitlement.pending, (state) => {
        state.createEntitlementLoading = true;
        state.createEntitlementFound = null;
      })
      .addCase(createEntitlement.fulfilled, (state) => {
        state.createEntitlementLoading = false;
        state.createEntitlementFound = true;
      })
      .addCase(createEntitlement.rejected, (state) => {
        state.createEntitlementLoading = false;
        state.createEntitlementFound = false;
      })

      .addCase(resetLine.pending, (state) => {
        state.resetLineLoading = true;
        state.resetLineFound = null;
      })
      .addCase(resetLine.fulfilled, (state, action) => {
        state.resetLineLoading = false;
        state.resetLineFound = action?.payload;
      })
      .addCase(resetLine.rejected, (state) => {
        state.resetLineLoading = false;
        state.resetLineFound = false;
      })

      .addCase(jobCreateEntitlements.pending, (state) => {
        state.jobCreateEntitlementLoading = true;
      })
      .addCase(jobCreateEntitlements.fulfilled, (state) => {
        state.jobCreateEntitlementLoading = false;
      })
      .addCase(jobCreateEntitlements.rejected, (state) => {
        state.jobCreateEntitlementLoading = false;
      });
  },
});

export const {
  //Common
  handleResetErpSalesOrderItemsPage,
  handlereseterpSalesOrderItemsGRIDCount,
  setOpenAlertBox,
  setCloseAlertBox,
  setAlertMessage,
  handleSearchOption,
  handleERPSalesOrderItemsDisplay,
  handleloadingForfetchERPSalesOrderItemsData,
  handleErpSalesOrderItemsSearchDate,
  handleImportStatus,
  handleMappingType,
  handleFastFindSearchOptions,
  handleSelectedTab,
  setCustomerSelectedValue,
  setCustomerNameInputValue,
  setCustomerNameSearchTerm,
  setShowCustomernameSelectedValue,
  setOrderGroupsSelectedValue,
  setOrderGroupInputValue,
  setOrderGroupSearchTerm,
  setShowOrdergroupSelectedValue,
  handleImportStatusOperator,
  handleErpSalesOrderItemsGridSelectedRow,
  handleErpSalesOrderItemsUnsupportedFlag,
  setERPSalesOrderItemsGridFilters,
  setErpSalesOrderItemsSearchGridColData,
  //Modals
  //Accounting Group
  setSelectedAccountGridRowsData,
  handleFilteredAccountingGroupData,
  setAccountingGroupModalOpen,
  setAccountingGroupModalClose,
  setAccouningGroupFormFeilds,
  //Sales Product
  setSalesProduct,
  setSalesModalData,
  setOpenSalesProductModal,
  setCloseSalesProductModal,
  setSalesProductCode,
  resetModalFields,
  //Master Customer Number Modal
  setmcnSelectedValue,
  setmcnCustomerNameInputValue,
  setDropDownValue,
  setmcnShowCustomernameSelectedValue,
  setmcnSelectedAccountGridRowsData,
  setmcnAccountingGroupModalOpen,
  setmcnAccountingGroupModalClose,
  setmcnAccouningGroupFormFeilds,
  setParentGlobalCustomerNoModalOpen,
  setParentGlobalCustomerNoModalClose,
  setmcnCustomerNameSearchTerm,
  setSelectedParentGlobalGridRowsData,
  setCustomersGridPageSize,
  handleParentGlobalModalReset,
  handleOpenParentGlobalCustomerNoModal,
  setCustomerNumber,
  selectSearchOption,
  resetValues,
  hendleAGChange,
  hendleSalesProductChange,
  handleOnSaveRefreshSearch,
  handleFromErpSalesOrderNavigate,
} = erpSalesOrderItemsSlice.actions;

export default erpSalesOrderItemsSlice.reducer;
